import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class HasRoleGuard implements CanActivate {
  constructor(private userService:UserService,
              private router:Router){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return route.data['role'].includes(this.userService.userRole) || this.router.createUrlTree(['']);

      // if(route.data['role'].includes(this.userService.userRole)){
      //   return true;
      // }
      // this.router.navigate(['']);
      // return false;
  }
  
}
